/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useHideOn } from '../../utils/contexts/ResponsiveProvider'
import breakpoints, { mediaQuery } from '../../utils/constants/breakpoints'

export const generateFlexColumnStyle = ({
  flex,
  width,
  alignSelf,
  wrapOn,
  orderOnSmall,
  maxWidth,
  widthOnSm,
  scroll,
  invisibleOn
}) => `
		flex: ${flex === undefined ? 0 : flex};
		align-self: ${alignSelf};
		width: ${width};
		flex-basis: ${width};
		max-width: ${maxWidth || '100%'};
		${scroll ? `overflow-y: scroll;` : ''};

		${mediaQuery(invisibleOn, 'visibility: hidden; width: 0; flex: 0;')}
		${mediaQuery(wrapOn, 'flex-basis: 100%;')}

		@media (max-width: ${breakpoints.sm}px) {
			${widthOnSm ? `min-width: ${widthOnSm};` : ''}
			${widthOnSm ? `flex-basis: ${widthOnSm};` : ''}
			${orderOnSmall ? `order: ${orderOnSmall};` : ''}
		}
`

export const FlexColumn = props => {
  const { flex, alignSelf, width, children, wrapOn, hideOn, invisibleOn, orderOnSmall, bgColor, widthOnSm, scroll } =
    props
  const shouldHide = useHideOn(hideOn)
  if (shouldHide) return false

  const style = css`
    background: ${bgColor};
    ${generateFlexColumnStyle({
      flex,
      alignSelf,
      width,
      wrapOn,
      orderOnSmall,
      widthOnSm,
      scroll,
      invisibleOn
    })}
  `

  return (
    <div className="flexCol" css={style}>
      {children}
    </div>
  )
}

export const FlexCol = FlexColumn

const FlexGrid = props => {
  const {
    justify,
    align,
    gutter,
    paddingGutter,
    direction,
    wrap,
    padding,
    directionOnSmall,
    fullHeight,
    minHeight,
    flex,
    children
  } = props

  const style = css`
    display: flex;
    flex: ${flex};
    justify-content: ${justify || 'center'};
    align-items: ${align || 'center'};
    padding: ${padding || 0};
    flex-direction: ${direction || 'row'};
    ${wrap ? 'flex-wrap: wrap;' : ''}
    ${fullHeight ? 'height: 100vh;' : ''}
		min-height: ${minHeight || '100%'};
    margin: ${-(gutter || paddingGutter)}rem;

    & > * {
      margin: ${gutter}rem !important;
      padding: ${paddingGutter}rem !important;
    }

    @media (max-width: ${breakpoints.sm}px) {
      ${directionOnSmall ? `flex-direction: ${directionOnSmall};` : ''}
    }
  `

  return (
    <div className="flexGrid" css={style}>
      {children}{' '}
    </div>
  )
}

export default FlexGrid
